<template>
  <CForm ref="uploaimage">
    <Loading v-if="isLoading"></Loading>
    <div v-else>
      <CRow>
        <CCol sm="6">Images here</CCol>
      </CRow>
      <CRow >
        <CCol sm="3">
          <template  v-if="promotion.images_on_page === null">
          <CInputFile
            ref="fileupload"
            label
            accept="image/*"
            invalid-feedback="Name should be filled"
            required
            @change="onFileChange"
          />

          <CInput
            :type="'hidden'"
            required
            v-model="$v.uploadImageForm.images_on_page.$model"
            :is-valid="!$v.uploadImageForm.images_on_page.$invalid"
          ></CInput>

          <CButton @click="submitForm" v-if="promotion.images_on_page === null" :disabled="$v.uploadImageForm.$invalid" color="success">
            <i class="fa fa-save"></i>
            Upload Image
          </CButton>&nbsp;
          </template>
          <CButton @click="removeImage" color="danger">
            <i class="fa fa-remove"></i>
            Remove
          </CButton>
        </CCol>
        <CCol sm="2">
          <div>Preview</div>
          <CCard v-if="promotion.images_on_page === null && uploadImageForm.images_on_page !== null">
            <CImg :src="uploadImageForm.images_on_page" :thumbnail="true" />
          </CCard>
          <CCard v-else-if="promotion.images_on_page !== null">
            <CImg :src="'https://storage.googleapis.com/isikulkas/'+promotion.images_on_page+'?r='+unixTime" :thumbnail="true" />
          </CCard>
          <CCard v-else>
            <CCardBody>
              <CRow>
                <CCol sm="12">No image</CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <!-- <CRow v-else>
        <CCol sm="3">
          <CImg v-if="promotion.images_on_page !== null" :src="'https://storage.googleapis.com/isikulkas/'+promotion.images_on_page+'?r='+unixTime" :thumbnail="true" />
        </CCol>
      </CRow> -->
    </div>
  </CForm>
</template>

<script>
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../../templates/Loading";
import { required } from "vuelidate/lib/validators";

export default {
  name: "UploadImageOnPage",
  components: { Loading },
  data() {
    return {
      title: "Upload Image On Page",
      items: [],
      uploadImageForm: tableInterfaces.promotion,
      isLoading: false,
      image: null,
      activeTab: 0,
      unixTime: Math.floor(Math.random() * (0 - 9999999999 + 1) ) + 0
    };
  },
  props: {
    promotion: {
      type: [Array, Object],
      default: () => [],
    },
    promotionStatus: {
      type: String,
      default: null
    },
  },
  validations: {
    uploadImageForm: {
      images_on_page: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },

  methods: {
    init: function () {
      this.unixTime = Math.floor(Math.random() * (0 - 9999999999 + 1) ) + 0;
    },
    back: function () {
      this.$router.go(-1);
    },
    submitForm: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        this.uploadImageForm.id = this.promotion.id;
        this.uploadImageForm.flag = 2;
        this.axios.put("console/news/update-image", this.uploadImageForm).then((response) => {
          this.showInfoNotification({
            title: "Ubah Image",
            message: response.data.message,
          });
        }).catch((error) => {
          this.expired(error, "Ubah Image");
        }).finally(() => {
          this.isLoading = false;
          // let route = this.$route.path.split("/");
          // this.init(route[4]);
          this.$router.go(0);
        });
      }
    },
    
    onFileChange(e) {
      this.createImage(e[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
        this.uploadImageForm.images_on_page = e.target.result;
      };
      console.log(this.uploadImageForm);
      reader.readAsDataURL(file);
    },
    removeImage: function (e) {
       if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        var remove = {'images_on_page': this.promotion.images_on_page, 'id': this.promotion.id, 'flag': 2};
        this.axios.put("console/news/remove-image", remove).then((response) => {
          this.$refs.uploaimage.reset();
          this.$refs.fileupload.value = null;
          this.uploadImageForm.images_on_page = null;
          this.promotion.images_on_page = null;
        }).catch((error) => {
          this.expired(error, "Ubah Image");
        }).finally(() => {
          this.isLoading = false;
          this.$router.go(0);
        });
      }
    },
  },
  mounted() {},
};
</script>
